import { render, staticRenderFns } from "./StartedAssignment.vue?vue&type=template&id=f13be22a&scoped=true&"
import script from "./StartedAssignment.vue?vue&type=script&lang=js&"
export * from "./StartedAssignment.vue?vue&type=script&lang=js&"
import style0 from "./StartedAssignment.vue?vue&type=style&index=0&id=f13be22a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13be22a",
  null
  
)

export default component.exports